import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import type { ProgressBarComparisonOptions } from './m-progress-bar-comparison.component.types';
import type { TooltipOptions } from 'primeng/api';
import { NgClass } from '@angular/common';
import { MTooltipComponent } from '../m-tooltip/m-tooltip.component';
import { ProgressBar } from 'primeng/progressbar';
import { MTagComponent } from '../m-tag/m-tag.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-progress-bar-comparison',
  templateUrl: './m-progress-bar-comparison.component.html',
  styleUrls: ['./m-progress-bar-comparison.component.scss'],
  imports: [NgClass, MTooltipComponent, ProgressBar, MTagComponent]
})
export class MProgressBarComparisonComponent implements OnInit {
  @Input() options!: ProgressBarComparisonOptions;
  @Input() tooltipOptions: TooltipOptions = {};

  prevPeriodPercentage!: number;
  curPeriodPercentage!: number;

  ngOnInit(): void {
    this.calculatePercentages();
    this.tooltipOptions = {
      positionTop: -10
    };
  }

  private calculatePercentages(): void {
    const maxVal = Math.max(
      this.options.prevPeriodValue,
      this.options.curPeriodValue
    );
    this.prevPeriodPercentage = (this.options.prevPeriodValue / maxVal) * 100;
    this.curPeriodPercentage = (this.options.curPeriodValue / maxVal) * 100;
  }
}
